import { ref } from "vue";

import store from "../state/store"
import useSortData from './useSortData';

export default function useProducts() {

    const productStatus = ref("")
    const search = ref("")
    const categoryId = ref("");
    const createdBy = ref("");
    const perPage = ref(10)
    const loading = ref(false)


    const getProducts = (url = null) => {
        store.dispatch("getProducts", {
            url,
            search: search.value,
            categoryId: categoryId.value,
            createdBy: createdBy.value,
            status: productStatus.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }

    const { sortField, sortDirection, sortData } = useSortData(getProducts);

    const sortProducts = (field) => {
        sortData(field);
        getProducts();
    };


    return {
        productStatus,
        search,
        categoryId,
        createdBy,
        perPage,
        sortField,
        sortDirection,
        loading,
        getProducts,
        sortProducts
    }
}